export const formatCurrency = (amount: any): string => {
  if (typeof amount === "string") {
    // Remove $ and commas from the string
    amount = amount.replace(/[$,]/g, "");
  }

  const validAmount = isNaN(Number(amount)) ? 0 : Number(amount);

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
  }).format(validAmount);
};

export const formatCurrencywithoutDoller = (amount: any): string => {
  const validAmount = isNaN(Number(amount)) ? 0 : Number(amount);
  
  const formattedAmount = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
  }).format(validAmount);

  return formattedAmount.replace('$', ' ');
};